import {
  ArrowPathIcon,
  CheckIcon,
  ViewfinderCircleIcon,
  XMarkIcon
} from "@heroicons/react/20/solid";
import {
  SCAN_STATE_CURRENT,
  SCAN_STATE_PROCESS_BASE, SCAN_STATE_OTHER, SCAN_STATE_RACK_NOT_SCANNED, SCAN_STATE_STANDBY, SCAN_STATE_WAITING
} from "../../../services/live-interface/dior/dior-interface-service";


export const DiorScanState = ({ scanState, processes }) => {
  const borderColor = scanState === SCAN_STATE_CURRENT ? 'border-perception-blue'
    : scanState >= SCAN_STATE_PROCESS_BASE ? 'border-perception-success-300'
      : scanState === SCAN_STATE_RACK_NOT_SCANNED ? 'border-warning' : 'border-perception-black-500';

  return (
    <>
      <div className={`absolute ${scanState !== SCAN_STATE_STANDBY ? 'opacity-100' : 'opacity-0'} transition-all pointer-events-none top-0 left-0 w-full h-full z-50 bg-black/40 backdrop-blur flex justify-center items-center`}>
        <div className={`w-4/5 h-4/5 flex flex-col justify-center items-center gap-4 text-5xl rounded-md bg-perception-black-500 border-4 ${borderColor}`}>
          {
            scanState === SCAN_STATE_CURRENT ?
              <>
                <ViewfinderCircleIcon aria-hidden="true" className="size-36 text-perception-blue" />
                <div className="text-perception-blue">
                  Scanning...
                </div>
              </>
            : scanState === SCAN_STATE_WAITING ?
              <>
                <ArrowPathIcon aria-hidden="true" className="size-36" />
                <div>
                  Please wait before scanning the next rack...
                </div>
              </>
            : scanState === SCAN_STATE_RACK_NOT_SCANNED ?
              <>
                <XMarkIcon aria-hidden="true" className="size-36 text-warning" />
                <div className="text-warning">
                  New rack not scanned!
                </div>
              </>
            : scanState === SCAN_STATE_OTHER ?
              <>
                <XMarkIcon aria-hidden="true" className="size-36" />
                <div>
                  Non managed process identified
                </div>
              </>
            : processes?.[scanState - SCAN_STATE_PROCESS_BASE]?.commentary?.toLowerCase() === 'rework' ?
              <>
                <CheckIcon aria-hidden="true" className="size-36 text-perception-success-300" />
                <div className="text-perception-success-300">
                  Rework process identified
                </div>
              </>
            : scanState >= SCAN_STATE_PROCESS_BASE ?
              <>
                <CheckIcon aria-hidden="true" className="size-36 text-perception-success-300" />
                <div className="text-perception-success-300">
                  Process {processes?.[scanState - SCAN_STATE_PROCESS_BASE]?.name ?? '(Unknown process)'} identified
                </div>
              </>
            :
              <>
                <ViewfinderCircleIcon aria-hidden="true" className="size-36 text-perception-gray-700" />
                <div className="text-perception-gray-700">
                  Waiting for a cart to scan...
                </div>
              </>
          }
        </div>
      </div>

      {/* Default block */}
      <div className="w-full h-48 min-h-48 flex flex-col justify-center items-center gap-4 text-xl rounded-md bg-perception-black-500 border-4 border-perception-black-500">
        <ViewfinderCircleIcon aria-hidden="true" className="size-16 text-perception-gray-700" />
        <div className="text-perception-gray-700">
          Waiting for a cart to scan...
        </div>
      </div>
    </>
  );
};
